import ActionTypes from "./ActionTypes";

const get_schedule = (payload) => {
    
  return {
    type: ActionTypes.GET_SCHEDULE,
    payload,
  };
};

const sales_history = (payload) => {
  
  return {
    type: ActionTypes.SALES_HISTORY,
    payload,
  };
};

export {get_schedule, sales_history};
